module.exports = __webpack_public_path__ + "img/icon_job_04.8484919b.svg";